import type {ProgramInviteTarget} from '../../../../modules/invites/stores/types';
import type {SendInvitesResult} from './SendInvitesStrategy';
import type {SendInvitesParams} from './types';

import {inviteStore} from '../../../../api/invite';
import {AppError} from '../../../../utils/errors/app';
import {logger} from '../../../../utils/logger';
import {SendInvitesStrategy} from './SendInvitesStrategy';

export class SendInvitesToProgramStrategy extends SendInvitesStrategy {
  constructor(
    private readonly programInviteTarget: ProgramInviteTarget,
    private readonly params: SendInvitesParams,
  ) {
    super(params);
  }

  async sendInvites(): Promise<SendInvitesResult> {
    const {message, recipients, send_copy} = this.params;

    if (!recipients || recipients.length === 0) {
      throw new AppError('No recipients specified');
    }

    const recipientsCount = recipients.length ?? 0;

    logger.event('invite_send_type', {
      message_added: this.params.message ? 'yes' : 'no',
      send_copy: this.params.send_copy ? 'yes' : 'no',
      type: 'program',
    });

    await inviteStore.sendToProgram({
      message,
      program_id: this.programInviteTarget._id,
      recipients: this.mapInviteRecipientsToRequestRecipients(recipients),
      send_copy,
    });

    return {
      message: this.getDefaultSuccessMessage(),
      title: this.getDefaultSuccessTitle(recipientsCount),
    };
  }
}
